import { render, staticRenderFns } from "./YourData.vue?vue&type=template&id=16274c5e&scoped=true&"
import script from "./YourData.vue?vue&type=script&lang=js&"
export * from "./YourData.vue?vue&type=script&lang=js&"
import style0 from "./YourData.vue?vue&type=style&index=0&id=16274c5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16274c5e",
  null
  
)

export default component.exports